// extracted by mini-css-extract-plugin
export default {"wrapper_404":"PageNotFound_wrapper_404__wdEzE","img_404":"PageNotFound_img_404__Cn00c"};